import Content from "components/Content";
import Label from "components/Label";
import React, { FC } from "react";

import styles from "./styles.module.scss";

const ShareLink: FC = () => {
  return (
    <Content
      containerClassName={styles.wrapper}
      contentClassName={styles.container}
    >
      <Label className={styles.title} variant="h-centered" color="white">
        Refer now
      </Label>
      <div className={styles.share} id="share" data-grsf-block-form />
    </Content>
  );
};

export default ShareLink;
